






















import Vue from 'vue'
import PartnerServiceContractItem from './PartnerServiceContract.vue'
import { PartnerServiceContract } from '@/types/generated/graphql'
import SERVICE_CONTRACT_QUERY from '@/graphql/partner/validPartnerServiceContracts.gql'

export default Vue.extend({
  name: 'PartnerServiceContractList',
  components: { PartnerServiceContractItem },
  methods: {
    onClickServiceContract(serviceContract: PartnerServiceContract) {
      this.$router.push({
        name: 'ServiceHome',
        params: { id: serviceContract.partnerServiceContractId },
      })
    },
  },
  apollo: {
    validPartnerServiceContracts: {
      query: SERVICE_CONTRACT_QUERY,
    },
  },
})
